export enum WorkflowParameterType {
    Boolean,
    String,
    Long,
    Double,
    DateTime,
    Password
}
